<span
	class="badge-indicator comment-notifications-indicator"
	[matTooltip]="'comment-notifications-unviewed-plural' | translate:{number: unviewedComments}">
	<i class="ficon-app-comment-outline"></i>
	<span class="unviewed-direct-value">
		{{unviewedComments}}
	</span>
</span>
